var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('a',{attrs:{"href":"https://github.com/apps/bionic-metrics"}},[_vm._v("Install GitHub App")])])}
var staticRenderFns = []

export { render, staticRenderFns }